import React, { useEffect, useState } from "react";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";
import DatePicker from "react-multi-date-picker";
import { useNavigate } from "react-router-dom";

export default function ListOfContract({ lang, path, heading, status, type }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  // const isLighMode =
  //   JSON.parse(
  //     JSON.parse(sessionStorage.getItem("aman-admin") || "")?.admin || "",
  //   )?.light_mode === "yes";

  const [contractList, setContractList] = useState([]);
  const [branchId, setBranchId] = useState();
  const [filter, setFilter] = useState([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [investorList, setInvestorList] = useState([]);
  const [investor, setInvestor] = useState();
  const [totalContractValue, setTotalContractValue] = useState();

  const navigate = useNavigate();

  function convertDateFormat(inputDate) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };

    const formattedDate = dateObject.toLocaleDateString("en-GB", options);
    return formattedDate;
  }

  const columns = [
    {
      header: lang.reference_number || "Reference Number",
      accessorKey: "id",
      cell: (row) => row.getValue() * 9999,
      footer: info => lang["Total"] || "Total"
    },
    {
      header: lang.Clients || "Clients",
      accessorKey: "customer_name",
    },
    {
      header: lang.Investors || "Clients",
      accessorKey: "investor_name",
    },
    {
      header: lang.date || "Date",
      accessorKey: "date_contract",
      cell: (row) => <p>{convertDateFormat(row.getValue())}</p>,
    },
    {
      header: lang.Amount || "Amount",
      cell: (row) => (
        <p>{row.row.original.total_value - row.row.original.profit}</p>
      ),
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { total_value, profit } = row.original;
            return sum + Number(total_value || 0) - Number(profit || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Profit || "Profit",
      accessorKey: "profit",
      cell: (row) => {
        const { profit, discount, legal_fees } = row.row.original;
        let finalProfit = 0;
        if (discount > 0 && discount >= legal_fees) {
          finalProfit = profit - (discount - legal_fees);
        } else {
          finalProfit = profit;
        }
        return finalProfit;
      },
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { profit, discount, legal_fees } = row.original;
            let finalProfit = 0;
            if (discount > 0) {
              finalProfit = profit - (discount - legal_fees);
            } else {
              finalProfit = profit;
            }
            return sum + Number(finalProfit || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Office Profit"] || "Office Profit",
      accessorKey: "office_profit",
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { office_profit } = row.original;
            return sum + Number(office_profit || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang["Final Net Profit"] || "Final Net Profit",
      cell: (row) => row.row.original.profit - row.row.original.office_profit,
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { profit, office_profit } = row.original;
            return sum + Number(profit || 0) - Number(office_profit || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Total || "Total",
      accessorKey: "total_value",
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { total_value } = row.original;
            return sum + Number(total_value || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Paid_Up || "Paid up",
      accessorKey: "total_paid",
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { total_paid } = row.original;
            return sum + Number(total_paid || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Residual || "Residual",
      cell: (row) =>
        row.row.original.total_value -
        row.row.original.total_paid -
        row.row.original.discount,
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { total_value, total_paid, discount } = row.original;
            return (
              sum +
              Number(total_value || 0) -
              Number(total_paid || 0) -
              Number(discount || 0)
            );
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Discount || "Discount",
      cell: (row) => row.row.original.discount,
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { discount } = row.original;
            return sum + Number(discount || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <button
                type="button"
                onClick={() =>
                  navigate(
                    `/dashboard/contracts/valid-contract/complete-contract/${row.row.original.id}`
                  )
                }
                className="dropdown-item mt-0"
                // eslint-disable-next-line eqeqeq
                disabled={row.row.original.status != 2}
              >
                {lang.complete_contract || "Complete Contract"}
              </button>
            </li>
          </ul>
        </div>
      ),
    },
  ];
  useEffect(() => {
    if (filter !== "from_to") {
      setFrom();
      setTo();
    }
    if (branchId) {
      try {
        axios
          .get(apiKey + "/contract-reports", {
            params: {
              branch_id: branchId,
              filter,
              from,
              to,
              investor,
              status,
              type,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setContractList(res.data.result);
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (err) {
        console.error(err);
      }

      axios
        .get(apiKey + "/investor", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setInvestorList(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
      axios
        .get(apiKey + "/get-total-amount", {
          params: {
            branch_id: branchId,
            investor_id: investor,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setTotalContractValue(res.data.result);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [branchId, filter, from, to, investor, status, type, token]);

  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id,
    );
  }, []);
  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Reports || "Reports"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">{lang.Reports || "Reports"}</li>
              <li className="breadcrumb-item active">{path}</li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="mt-3 mb-3">
                    <div className="rr">{heading}</div>

                    <div className="row row justify-content-end gap-2">
                      {filter === "from_to" && (
                        <>
                          <div className="custom-datepicker">
                            <DatePicker
                              className="form-control w-100"
                              placeholder={lang["from_text"] || "From"}
                              style={{
                                left: "35%",
                                top: "5px",
                                height: "auto",
                              }}
                              containerStyle={{
                                height: "auto",
                              }}
                              onChange={(e) => {
                                const dateObject = new Date(e);
                                setFrom(dateObject);
                              }}
                            />
                          </div>
                          <div className="custom-datepicker">
                            <DatePicker
                              className="form-control w-100"
                              placeholder={lang["to_text"] || "To"}
                              style={{
                                left: "45%",
                                top: "5px",
                                height: "auto",
                              }}
                              containerStyle={{
                                height: "auto",
                              }}
                              onChange={(e) => {
                                const dateObject = new Date(e);
                                setTo(dateObject);
                              }}
                            />
                          </div>
                        </>
                      )}
                      <select
                        onChange={(e) => setInvestor(e.target.value)}
                        name=""
                        id=""
                        className="form-data col-3 btn-export"
                        style={{ top: "48px" }}
                      >
                        <option value="">
                          {lang.all_investors || "All Investors"}
                        </option>
                        {investorList.map((investor, index) => (
                          <option key={index} value={investor.id}>
                            {investor.FullName}
                          </option>
                        ))}
                      </select>
                      <select
                        onChange={(e) => setFilter(e.target.value)}
                        name=""
                        id=""
                        className="form-data btn-export col-3"
                      >
                        <option value="">{lang.All_Time || "All Time"}</option>
                        <option value="today">{lang.Today || "Today"}</option>
                        <option value="this_week">
                          {lang.This_Week || "This Week"}
                        </option>
                        <option value="this_month">
                          {lang.This_Month || "This Month"}
                        </option>
                        <option value="this_year">
                          {lang.This_Year || "This Year"}
                        </option>
                        <option value="from_to">
                          {lang["From To"] || "From To"}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div classNames="d-flex mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={contractList}
                      columns={columns}
                      totalContractValue={totalContractValue}
                      footer={true}
                      exportOption={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
